import { SubMenuSerializer } from './SubMenuSerializer';

class MenuSerializer {
  static deSerialize(data) {
    return {
      name: data.FArNombre,
      id: String(data.FArID),
      index: data.FArOrdenWeb,
      imageUrl: data.FArImagen,
      subMenus: (data.SubFamiliaArticulos || []).map(SubMenuSerializer.deSerialize),
    };
  }
}

export { MenuSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/MenuSerializer.js